import { COUNTRY, CURRENCY, KHQR, TAG } from "ts-khqr"
import {merchantInfo} from '../constants/env';

interface qrProps{
  type: 'individual' | 'merchant';
  amount: number;
  currencyUser: 'USD' | 'KHR';
  merchanID?: string;
  merchantName?: string;
}

const EXPIRY_MS = 3 * 60 * 1000 // 3 minutes, matches the 180s countdown in User.tsx

export const generateQR = ({ amount, type, currencyUser, merchanID,merchantName }: qrProps) =>{
  const expirationTimestamp = amount ? Date.now() + EXPIRY_MS : undefined

  const basePayload = {
    accountID: merchanID || merchantInfo.accountID,
    merchantName: merchantName || merchantInfo.merchantName,
    merchantID: merchanID || merchantInfo.merchantID,
    acquiringBank: "",
    merchantCity: merchantInfo.merchantCity,
    currency: currencyUser === 'USD' ? CURRENCY.USD : CURRENCY.KHR,
    amount: amount,
    countryCode: COUNTRY.KH,
    additionalData: {
      mobileNumber: merchantInfo.additionalData.mobileNumber,
      billNumber: merchantInfo.additionalData.billNumber,
      storeLabel: merchantInfo.additionalData.storeLabel,
      terminalLabel: merchantInfo.additionalData.terminalLabel,
      purposeOfTransaction: merchantInfo.additionalData.purposeOfTransaction
    },
    languageData: {
      languagePreference: merchantInfo.languageData.languagePreference,
      merchantNameAlternateLanguage: merchantInfo.languageData.merchantNameAlternateLanguage,
    },
    upiMerchantAccount: merchantInfo.upiMerchantAccount,
    expirationTimestamp,
  }

  return KHQR.generate({
    tag: type === 'individual' ? TAG.INDIVIDUAL : TAG.MERCHANT,
    ...basePayload,
  })
}